import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Pode criar um arquivo vazio se não tiver
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);